module.exports = __webpack_public_path__ + "static/media/UBC.433c5df0.png";